import { appConfig } from '../../../config/customization';
import Device from '../../../constants/deviceSizes';

const textStyle = {
  boxSizing: 'border-box',
  position: 'relative',
  left: '-11px',
  top: 2,
  textAlign: 'left',
  minHeight: 30,
  paddingBottom: 10,
  paddingLeft: 15,
  zIndex: 1,
  width: '100%'
};

export default {
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    minHeight: 30,
    width: '70%',
    [Device.mobile]: {
      width: '90%'
    }
  },
  dot: {
    fill: appConfig.colors.lightBlue,
    stroke: appConfig.colors.lightBlue,
    position: 'relative',
    strokeOpacity: '.4',
    strokeWidth: 8,
    zIndex: 3
  },
  lineContainer: {
    height: 50,
    width: 20
  },
  base: {
    fill: appConfig.colors.bulletsBase,
    stroke: appConfig.colors.bulletsBase,
    borderColor: appConfig.colors.bulletsBorderBase
  },
  gray: {
    fill: appConfig.colors.gray,
    stroke: appConfig.colors.gray,
    borderColor: appConfig.colors.lightGray
  },
  green: {
    fill: appConfig.colors.green,
    stroke: appConfig.colors.green,
    borderColor: appConfig.colors.translucentGreen
  },
  darkBlue: {
    fill: appConfig.colors.sidebarColor,
    stroke: appConfig.colors.sidebarColor,
    borderColor: appConfig.colors.translucentBlue
  },
  red: {
    fill: appConfig.colors.redVoucher,
    stroke: appConfig.colors.redVoucher,
    borderColor: appConfig.colors.translucentRedVoucher
  },
  line: {
    strokeWidth: 3
  },
  text: {
    ...textStyle,
    borderLeft: `3px solid ${appConfig.colors.translucentLightBlue}`
  },
  last: {
    ...textStyle,
    paddingLeft: 18
  }
};
